var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointMarkerKerna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wmlrcylh5a",
    width: "158.5%",
    height: "218.2%",
    x: "-29.3%",
    y: "-59.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1148 -153) translate(365 30) translate(789 123)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.5 30C34.822 30 44 34.253 44 39.5c0 4.752-7.528 8.689-17.358 9.39-.075.07-.16.128-.255.172l-2.465 1.149c-.267.124-.577.124-.844 0l-2.465-1.149c-.096-.045-.182-.103-.256-.171C10.527 48.188 3 44.25 3 39.5c0-5.247 9.178-9.5 20.5-9.5z",
    filter: "url(#wmlrcylh5a)",
    opacity: 0.235
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C67F3",
    d: "M24 0c13.255 0 24 10.745 24 24 0 12.3-9.253 22.439-21.177 23.836l-2.116 2.114c-.39.39-1.024.39-1.414 0l-2.116-2.114C9.253 46.439 0 36.3 0 24 0 10.745 10.745 0 24 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 56,
    r: 3,
    fill: "#4C67F3",
    transform: "matrix(-1 0 0 1 48 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 10,
    fill: "#FFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointMarkerKerna);
export default __webpack_public_path__ + "static/media/point-marker-kerna.520e6b0f1461005077ab13e43146ec25.svg";
export { ForwardRef as ReactComponent };